<ngu-modal #modal [MIndex]="confirmModalIndex" (afterend)="destroy()">
  <h4>{{confirmData.heading}}</h4>
  <p>{{confirmData.body}}</p>
  <div class="confirmBtn">
    <!-- <button #no class="cancel">{{confirmData.noButton}}</button>
    <button #yes class="confirm">{{confirmData.yesButton}}</button> -->
    <ng-container *ngFor="let btn of confirmData.buttons">
      <button #buttons [value]="btn.value" class="btnCol" [ngClass]="btn.color || 'confirm'">{{btn.name}}</button>
    </ng-container>
  </div>
</ngu-modal>
<!-- <ngu-modal #modal [MIndex]="confirmModalIndex" (afterend)="destroy()">
  <h4>{{confirmData.heading}}</h4>
  <p>{{confirmData.body}}</p>
  <div class="confirmBtn">
    <button #no class="cancel">{{confirmData.noButton}}</button>
    <button #yes class="confirm">{{confirmData.yesButton}}</button>
  </div>
</ngu-modal> -->
